import { render, staticRenderFns } from "./OvertimeListAddNew.vue?vue&type=template&id=1560b230&"
import script from "./OvertimeListAddNew.vue?vue&type=script&lang=js&"
export * from "./OvertimeListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./OvertimeListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports